<template>
  <div class="card-document" :class="customClasses">
    <div class="card-document__inner">
      <ElementPreview class="card-document__preview" type="document" :display="display" :text="content.fileType" />
      <div class="card-document__description">
        <CardDocumentDetails :content="content" />
        <CardDocumentButtons
          v-if="isDesktop"
          :url="content.url"
          :zip-url="content.zipUrl"
          :guid="content.guid"
          :bookmarked="content.bookmarked" />
      </div>
    </div>
  </div>
</template>

<script>
import ElementPreview from '@elements/ElementPreview'
import CardDocumentDetails from './CardDocumentDetails'
import CardDocumentButtons from './CardDocumentButtons'

import { mapGetters } from 'vuex'

export default {
  name: 'CardDocument',
  props: {
    content: {
      type: Object,
      required: true
    },
    display: {
      type: String,
      required: false,
      default: 'large'
    }
  },
  components: {
    ElementPreview,
    CardDocumentButtons,
    CardDocumentDetails
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice'
    }),
    isDesktop () {
      return this.device === 'desktop'
    },
    customClasses () {
      return [
        `card-document--${this.display}`
      ]
    }
  }
}
</script>

<style lang="scss">
.card-document {

  @media print {
    background-color: transparent;
    border-left: 6px solid colors("documents");
    page-break-inside: avoid;
  }
  // Card Document MEDIUM LARGE

  &--medium,
  &--large{
    @include media("small-medium") {
      padding: layout("spacing")/2;
      border-top: 6px solid colors("documents");
    }
    @include media("large") {
      padding: layout("spacing");
      border-left: 6px solid colors("documents");
    }
  }

  width: 100%;
  border-radius: layout("border-radius");
  background-color: colors("foreground");

  // Inner

  &__inner{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  // Preview

  &__preview{
    flex: 0 0 auto;
  }

  // Description

  &__description{
    flex: 1;
    padding-left: layout("spacing");
    padding-bottom: layout("spacing")/2;

    .card-document--large &{
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
  }

  // Title

  &__title{
    a{
      margin-right: 1rem;
    }
  }
}
</style>
